<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-12-25 17:16:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refunddetail/components/TopStep/index.vue
-->
<template>
  <div class="con">
    <div
      v-for="(item, index) in stepList"
      :key="index"
      class="font12 font_weight500 colof step step1 line_height_17"
    >
      <div class="step_top">
        <div
          :class="{ line_color: index > stepIndex, none_line: index === 0 }"
          class="line"
        ></div>
        <img
          :src="index <= stepIndex ? item.iconUrl : item.iconUrl2"
          alt=""
          class="step_img"
        />
        <div
          :class="{
            line_color: index > stepIndex,
            none_line: index === stepList.length - 1
          }"
          class="line"
        ></div>
      </div>
      <div class="step_det">{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    stepIndex: {
      type: Number,
      return: 0
    }
  },
  // mounted() {
  //   console.log(this.stepIndex, "stepIndex");
  // },
  data() {
    return {
      stepList: [
        {
          iconUrl: require("@/assets/order/step_icon1@2x.png"),
          iconUrl2: require("@/assets/order/step_icon2@2x.png"),
          name: "申请售后"
        },
        {
          iconUrl: require("@/assets/order/step_icon1@2x.png"),
          iconUrl2: require("@/assets/order/step_icon2@2x.png"),
          name: "客服审核中"
        },
        {
          iconUrl: require("@/assets/order/step_icon1@2x.png"),
          iconUrl2: require("@/assets/order/step_icon2@2x.png"),
          name: "待商品寄回"
        },
        {
          iconUrl: require("@/assets/order/step_icon1@2x.png"),
          iconUrl2: require("@/assets/order/step_icon2@2x.png"),
          name: "商家待收货"
        },
        {
          iconUrl: require("@/assets/order/step_icon1@2x.png"),
          iconUrl2: require("@/assets/order/step_icon2@2x.png"),
          name: "售后完成"
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.con {
  background: linear-gradient(90deg, #bf9264 0%, #e1c49d 100%);
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  padding: 24px 0 37px;
  .step {
    flex: 1;
  }
  .step_top {
    display: flex;
    .step_img {
      width: 18px;
      // margin: 0 10px;
    }
    .line {
      bottom: 50%;
      transform: translateY(-50%);
      border-bottom: 2px solid rgba(255, 255, 255, 1);
      width: 100%;
      // margin-bottom: 8px;
    }
    .line_color {
      border-bottom: 2px solid rgba(255, 255, 255, 0.4) !important;
    }
    .none_line {
      border-bottom: 1px solid transparent !important;
    }
  }
  .step_det {
    margin-top: 8px;
  }
}
</style>
